<div class="viewer-wrapper">
  <h3 *ngIf="loading">Loading…</h3>
  <h3 class="error" *ngIf="error">{{ error }}</h3>
  <h3 *ngIf="ended && !error">This live stream has ended.</h3>
  <h3 *ngIf="!loading && !error && !ended && !hasStream">Waiting for the live stream to start...</h3>

  <button *ngIf="audioBlocked" (click)="enableSound()">🔊 Tap to enable sound</button>
  <div #remoteContainer class="remote-videos" [hidden]="!!error"></div>
</div>